
import "./Dish.css"; 

function Dish({ imgurl, title, price, desc }) {
  return (
    <div className="dish-card">
      <img src={imgurl} alt={title} className="dish-img"/>

      <h2 className="dish-title">{title}</h2>
      <p className="dish-price">{price}$</p>
      <p className="dish-desc">{desc}</p>
    </div>
  );
}

export default Dish;
